export default "__VITE_ASSET__CAxFo090__"